var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ae-fraction"},[_vm._v(" "+_vm._s(_vm.numerator)+"⁄"+_vm._s(_vm.denominator)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }